import { useParams } from 'react-router-dom';
import {
  Box,
  Typography,
  CircularProgress,
} from '@mui/material';
import { useEffect, useState } from 'react';
import axios from 'axios';

function CompanyReportsPage() {
  const { companyName } = useParams();
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchReports = async () => {
      try {
        const res = await axios.get(`/api/company-reports/${encodeURIComponent(companyName)}`, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        });
        setReports(res.data);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchReports();
  }, [companyName]);

  return (
    <Box sx={{ mt: 4, px: 3 }}>
      <Typography variant="h5" fontWeight={600} gutterBottom>
        Reports for {companyName}
      </Typography>

      {loading ? (
        <CircularProgress />
      ) : reports.length === 0 ? (
        <Typography>No reports found.</Typography>
      ) : (
        <Box sx={{ mt: 2 }}>
          {reports.map((r, i) => (
            <Box
              key={r._id || i}
              sx={{
                mb: 1,
                p: 2,
                bgcolor: '#f5f5f5',
                borderRadius: 1.5,
              }}
            >
              <Typography variant="body2" fontWeight={600}>
                ID: {r._id}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Created At: {new Date(r.createdAt).toUTCString()}
              </Typography>
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
}

export default CompanyReportsPage;
